import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/home/ubuntu/Lagerverwaltung/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/ubuntu/Lagerverwaltung/layouts/default.vue").then(m => m.default || m))
}